<template>
  <v-app>
    <div 
      :style="{'transform': `translate(-50%, -50%) scale(${scale*.95})`}" 
      class="app"
      >
      <Menu/>
      <router-view/>
    </div>
  </v-app>
</template>

<script>
import Menu from '@/components/Menu.vue'

export default {
  name: 'App',

  components: {
    Menu
  },

  data: () => ({
    scale: null
  }),

  mounted() {
    this.resizeBanner();
    window.onresize = () => this.resizeBanner();
  },

  methods: {
    resizeBanner() {
      this.scale = Math.min(
        document.body["offsetWidth"]/ 1920,    
        document.body["offsetHeight"]/ 1080
      );
    }
  },
};
</script>


<style scoped lang="scss">
.app{
  transform: translate(-50%, -50%);
  position: absolute;
  width: 1920px;
  height: 1080px;
  left: 50%;
  top: 50%;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0px 0px 20px 0px #0000005c;
}
</style>